function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#adc6ca",
  fillRule: "evenodd",
  d: "M12 3a9 9 0 11-.001 18.001A9 9 0 0112 3zm4.836 5.935a.436.436 0 00-.616-.002l-5.932 5.884-2.503-2.524a.436.436 0 00-.616-.002l-.309.306a.436.436 0 00-.002.616l3.116 3.142c.17.17.445.172.616.002l6.55-6.497a.436.436 0 00.002-.616z"
});

function SvgToastSuccessinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgToastSuccessinline;